"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.ContentType = exports.SravniReviewsModelsChartsTypeSeries = exports.SravniReviewsEnumsUserDataStatus = exports.SravniReviewsEnumsReviewStatus = exports.SravniReviewsEnumsReviewRateStatus = exports.SravniReviewsEnumsReviewRate = exports.SravniReviewsEnumsReviewOrder = exports.SravniReviewsEnumsReviewFilter = exports.SravniReviewsEnumsReviewAuthorRoleType = exports.SravniReviewsEnumsReputationGroupingType = exports.SravniReviewsEnumsReputationDetailField = exports.SravniReviewsEnumsRatingType = exports.SravniReviewsEnumsOrderDirection = exports.SravniReviewsEnumsModerationReasonType = exports.SravniReviewsEnumsExternalApiActivityEventType = exports.SravniReviewsEnumsDateInterval = exports.SravniReviewsEnumsCommentsOrderBy = exports.SravniReviewsEnumsActivityEventType = exports.SravniOrganizationsSharedReviewObjectType = exports.SravniOrganizationsSharedOrganizationType = void 0;
var SravniOrganizationsSharedOrganizationType;
(function (SravniOrganizationsSharedOrganizationType) {
    SravniOrganizationsSharedOrganizationType["Unknown"] = "unknown";
    SravniOrganizationsSharedOrganizationType["Bank"] = "bank";
    SravniOrganizationsSharedOrganizationType["Insurance"] = "insurance";
    SravniOrganizationsSharedOrganizationType["Mfo"] = "mfo";
    SravniOrganizationsSharedOrganizationType["EducationalOrganization"] = "educationalOrganization";
    SravniOrganizationsSharedOrganizationType["Broker"] = "broker";
    SravniOrganizationsSharedOrganizationType["Npf"] = "npf";
    SravniOrganizationsSharedOrganizationType["Leasing"] = "leasing";
    SravniOrganizationsSharedOrganizationType["Marketplace"] = "marketplace";
    SravniOrganizationsSharedOrganizationType["Bankruptcy"] = "bankruptcy";
    SravniOrganizationsSharedOrganizationType["University"] = "university";
    SravniOrganizationsSharedOrganizationType["Bookmaker"] = "bookmaker";
    SravniOrganizationsSharedOrganizationType["Investment"] = "investment";
    SravniOrganizationsSharedOrganizationType["NonbankingOrganization"] = "nonbankingOrganization";
    SravniOrganizationsSharedOrganizationType["MortgageAgent"] = "mortgageAgent";
    SravniOrganizationsSharedOrganizationType["Other"] = "other";
    SravniOrganizationsSharedOrganizationType["FoodRation"] = "foodRation";
})(SravniOrganizationsSharedOrganizationType = exports.SravniOrganizationsSharedOrganizationType || (exports.SravniOrganizationsSharedOrganizationType = {}));
var SravniOrganizationsSharedReviewObjectType;
(function (SravniOrganizationsSharedReviewObjectType) {
    SravniOrganizationsSharedReviewObjectType["Unknown"] = "unknown";
    SravniOrganizationsSharedReviewObjectType["Banks"] = "banks";
    SravniOrganizationsSharedReviewObjectType["InsuranceCompany"] = "insuranceCompany";
    SravniOrganizationsSharedReviewObjectType["CarService"] = "carService";
    SravniOrganizationsSharedReviewObjectType["CarModel"] = "carModel";
    SravniOrganizationsSharedReviewObjectType["Mfi"] = "mfi";
    SravniOrganizationsSharedReviewObjectType["EducationalOrganization"] = "educationalOrganization";
    SravniOrganizationsSharedReviewObjectType["Broker"] = "broker";
    SravniOrganizationsSharedReviewObjectType["Npf"] = "npf";
    SravniOrganizationsSharedReviewObjectType["Leasing"] = "leasing";
    SravniOrganizationsSharedReviewObjectType["Marketplace"] = "marketplace";
    SravniOrganizationsSharedReviewObjectType["Bankruptcy"] = "bankruptcy";
    SravniOrganizationsSharedReviewObjectType["University"] = "university";
    SravniOrganizationsSharedReviewObjectType["Bookmaker"] = "bookmaker";
    SravniOrganizationsSharedReviewObjectType["Investment"] = "investment";
    SravniOrganizationsSharedReviewObjectType["FoodRation"] = "foodRation";
})(SravniOrganizationsSharedReviewObjectType = exports.SravniOrganizationsSharedReviewObjectType || (exports.SravniOrganizationsSharedReviewObjectType = {}));
var SravniReviewsEnumsActivityEventType;
(function (SravniReviewsEnumsActivityEventType) {
    SravniReviewsEnumsActivityEventType["None"] = "none";
    SravniReviewsEnumsActivityEventType["ReviewAdded"] = "reviewAdded";
    SravniReviewsEnumsActivityEventType["ReviewEdited"] = "reviewEdited";
    SravniReviewsEnumsActivityEventType["ReviewDeleted"] = "reviewDeleted";
    SravniReviewsEnumsActivityEventType["ReviewChecked"] = "reviewChecked";
    SravniReviewsEnumsActivityEventType["CommentAdded"] = "commentAdded";
    SravniReviewsEnumsActivityEventType["CommentEdited"] = "commentEdited";
    SravniReviewsEnumsActivityEventType["CommentDeleted"] = "commentDeleted";
    SravniReviewsEnumsActivityEventType["CommentChecked"] = "commentChecked";
    SravniReviewsEnumsActivityEventType["RatingAccepted"] = "ratingAccepted";
    SravniReviewsEnumsActivityEventType["RatingChanged"] = "ratingChanged";
    SravniReviewsEnumsActivityEventType["RatingRejected"] = "ratingRejected";
    SravniReviewsEnumsActivityEventType["ProblemSolved"] = "problemSolved";
    SravniReviewsEnumsActivityEventType["ReviewFollowUp"] = "reviewFollowUp";
    SravniReviewsEnumsActivityEventType["DocumentsRequested"] = "documentsRequested";
    SravniReviewsEnumsActivityEventType["DocumentsRecieved"] = "documentsRecieved";
    SravniReviewsEnumsActivityEventType["DocumentsRemoved"] = "documentsRemoved";
    SravniReviewsEnumsActivityEventType["DocumentsRequestCancelled"] = "documentsRequestCancelled";
    SravniReviewsEnumsActivityEventType["DocumentsApproved"] = "documentsApproved";
    SravniReviewsEnumsActivityEventType["DocumentsFailed"] = "documentsFailed";
    SravniReviewsEnumsActivityEventType["ReviewRestored"] = "reviewRestored";
    SravniReviewsEnumsActivityEventType["CommentRestored"] = "commentRestored";
    SravniReviewsEnumsActivityEventType["ProblemSolutionReset"] = "problemSolutionReset";
    SravniReviewsEnumsActivityEventType["ReviewUnchecked"] = "reviewUnchecked";
    SravniReviewsEnumsActivityEventType["CommentUnchecked"] = "commentUnchecked";
    SravniReviewsEnumsActivityEventType["ReviewObjectTypeChanged"] = "reviewObjectTypeChanged";
    SravniReviewsEnumsActivityEventType["ReviewPreModerationApproved"] = "reviewPreModerationApproved";
    SravniReviewsEnumsActivityEventType["CommentPreModerationApproved"] = "commentPreModerationApproved";
    SravniReviewsEnumsActivityEventType["ReviewTagAdded"] = "reviewTagAdded";
    SravniReviewsEnumsActivityEventType["ReviewTagRemoved"] = "reviewTagRemoved";
    SravniReviewsEnumsActivityEventType["ReviewTagChanged"] = "reviewTagChanged";
    SravniReviewsEnumsActivityEventType["DocumentsChanged"] = "documentsChanged";
    SravniReviewsEnumsActivityEventType["AutomaticCommentDeleted"] = "automaticCommentDeleted";
    SravniReviewsEnumsActivityEventType["DocumentsRequestedAgain"] = "documentsRequestedAgain";
    SravniReviewsEnumsActivityEventType["HasCompanyResponse"] = "hasCompanyResponse";
})(SravniReviewsEnumsActivityEventType = exports.SravniReviewsEnumsActivityEventType || (exports.SravniReviewsEnumsActivityEventType = {}));
/** Тип сортировки комментариев */
var SravniReviewsEnumsCommentsOrderBy;
(function (SravniReviewsEnumsCommentsOrderBy) {
    SravniReviewsEnumsCommentsOrderBy["Created"] = "created";
})(SravniReviewsEnumsCommentsOrderBy = exports.SravniReviewsEnumsCommentsOrderBy || (exports.SravniReviewsEnumsCommentsOrderBy = {}));
var SravniReviewsEnumsDateInterval;
(function (SravniReviewsEnumsDateInterval) {
    SravniReviewsEnumsDateInterval["Day"] = "day";
    SravniReviewsEnumsDateInterval["Week"] = "week";
    SravniReviewsEnumsDateInterval["Month"] = "month";
    SravniReviewsEnumsDateInterval["Quarter"] = "quarter";
    SravniReviewsEnumsDateInterval["Year"] = "year";
})(SravniReviewsEnumsDateInterval = exports.SravniReviewsEnumsDateInterval || (exports.SravniReviewsEnumsDateInterval = {}));
var SravniReviewsEnumsExternalApiActivityEventType;
(function (SravniReviewsEnumsExternalApiActivityEventType) {
    SravniReviewsEnumsExternalApiActivityEventType["ReviewEdited"] = "reviewEdited";
    SravniReviewsEnumsExternalApiActivityEventType["ReviewChecked"] = "reviewChecked";
    SravniReviewsEnumsExternalApiActivityEventType["CommentAdded"] = "commentAdded";
    SravniReviewsEnumsExternalApiActivityEventType["CommentEdited"] = "commentEdited";
    SravniReviewsEnumsExternalApiActivityEventType["RatingAccepted"] = "ratingAccepted";
    SravniReviewsEnumsExternalApiActivityEventType["RatingChanged"] = "ratingChanged";
    SravniReviewsEnumsExternalApiActivityEventType["RatingRejected"] = "ratingRejected";
    SravniReviewsEnumsExternalApiActivityEventType["ProblemSolved"] = "problemSolved";
    SravniReviewsEnumsExternalApiActivityEventType["ProblemSolutionReset"] = "problemSolutionReset";
})(SravniReviewsEnumsExternalApiActivityEventType = exports.SravniReviewsEnumsExternalApiActivityEventType || (exports.SravniReviewsEnumsExternalApiActivityEventType = {}));
var SravniReviewsEnumsModerationReasonType;
(function (SravniReviewsEnumsModerationReasonType) {
    SravniReviewsEnumsModerationReasonType["None"] = "none";
    SravniReviewsEnumsModerationReasonType["EmailContent"] = "emailContent";
    SravniReviewsEnumsModerationReasonType["PhoneContent"] = "phoneContent";
    SravniReviewsEnumsModerationReasonType["AbusiveContent"] = "abusiveContent";
    SravniReviewsEnumsModerationReasonType["AutoModerationRequested"] = "autoModerationRequested";
    SravniReviewsEnumsModerationReasonType["Spam"] = "spam";
    SravniReviewsEnumsModerationReasonType["Fraud"] = "fraud";
    SravniReviewsEnumsModerationReasonType["ImageContent"] = "imageContent";
    SravniReviewsEnumsModerationReasonType["Link"] = "link";
    SravniReviewsEnumsModerationReasonType["TransliterationContent"] = "transliterationContent";
    SravniReviewsEnumsModerationReasonType["UnreadableContent"] = "unreadableContent";
    SravniReviewsEnumsModerationReasonType["ImportedRequiresConfirmation"] = "importedRequiresConfirmation";
    SravniReviewsEnumsModerationReasonType["InvalidContentMatching"] = "invalidContentMatching";
    SravniReviewsEnumsModerationReasonType["Duplicate"] = "duplicate";
})(SravniReviewsEnumsModerationReasonType = exports.SravniReviewsEnumsModerationReasonType || (exports.SravniReviewsEnumsModerationReasonType = {}));
/** Тип сортировки */
var SravniReviewsEnumsOrderDirection;
(function (SravniReviewsEnumsOrderDirection) {
    SravniReviewsEnumsOrderDirection["Asc"] = "asc";
    SravniReviewsEnumsOrderDirection["Desc"] = "desc";
})(SravniReviewsEnumsOrderDirection = exports.SravniReviewsEnumsOrderDirection || (exports.SravniReviewsEnumsOrderDirection = {}));
var SravniReviewsEnumsRatingType;
(function (SravniReviewsEnumsRatingType) {
    SravniReviewsEnumsRatingType["Default"] = "default";
    SravniReviewsEnumsRatingType["OrganizationOnly"] = "organizationOnly";
    SravniReviewsEnumsRatingType["ServiceTag"] = "serviceTag";
    SravniReviewsEnumsRatingType["SpecificProduct"] = "specificProduct";
    SravniReviewsEnumsRatingType["Locations"] = "locations";
    SravniReviewsEnumsRatingType["Filters"] = "filters";
})(SravniReviewsEnumsRatingType = exports.SravniReviewsEnumsRatingType || (exports.SravniReviewsEnumsRatingType = {}));
/** Список полей для csv */
var SravniReviewsEnumsReputationDetailField;
(function (SravniReviewsEnumsReputationDetailField) {
    SravniReviewsEnumsReputationDetailField["From"] = "from";
    SravniReviewsEnumsReputationDetailField["To"] = "to";
    SravniReviewsEnumsReputationDetailField["ReviewsCount"] = "reviewsCount";
    SravniReviewsEnumsReputationDetailField["ApprovedCount"] = "approvedCount";
    SravniReviewsEnumsReputationDetailField["RejectedCount"] = "rejectedCount";
    SravniReviewsEnumsReputationDetailField["AvgRatingValue"] = "avgRatingValue";
    SravniReviewsEnumsReputationDetailField["AnswersCount"] = "answersCount";
    SravniReviewsEnumsReputationDetailField["ResolvedCount"] = "resolvedCount";
    SravniReviewsEnumsReputationDetailField["AvgResponseTime"] = "avgResponseTime";
    SravniReviewsEnumsReputationDetailField["AvgResolvedTime"] = "avgResolvedTime";
    SravniReviewsEnumsReputationDetailField["PositiveVotesCount"] = "positiveVotesCount";
    SravniReviewsEnumsReputationDetailField["NegativeVotesCount"] = "negativeVotesCount";
    SravniReviewsEnumsReputationDetailField["ZeroRatingApprovedReviewsCount"] = "zeroRatingApprovedReviewsCount";
    SravniReviewsEnumsReputationDetailField["OneRatingApprovedReviewsCount"] = "oneRatingApprovedReviewsCount";
    SravniReviewsEnumsReputationDetailField["TwoRatingApprovedReviewsCount"] = "twoRatingApprovedReviewsCount";
    SravniReviewsEnumsReputationDetailField["ThreeRatingApprovedReviewsCount"] = "threeRatingApprovedReviewsCount";
    SravniReviewsEnumsReputationDetailField["FourRatingApprovedReviewsCount"] = "fourRatingApprovedReviewsCount";
    SravniReviewsEnumsReputationDetailField["FiveRatingApprovedReviewsCount"] = "fiveRatingApprovedReviewsCount";
})(SravniReviewsEnumsReputationDetailField = exports.SravniReviewsEnumsReputationDetailField || (exports.SravniReviewsEnumsReputationDetailField = {}));
var SravniReviewsEnumsReputationGroupingType;
(function (SravniReviewsEnumsReputationGroupingType) {
    SravniReviewsEnumsReputationGroupingType["Days"] = "days";
    SravniReviewsEnumsReputationGroupingType["Weeks"] = "weeks";
    SravniReviewsEnumsReputationGroupingType["Months"] = "months";
    SravniReviewsEnumsReputationGroupingType["Years"] = "years";
})(SravniReviewsEnumsReputationGroupingType = exports.SravniReviewsEnumsReputationGroupingType || (exports.SravniReviewsEnumsReputationGroupingType = {}));
var SravniReviewsEnumsReviewAuthorRoleType;
(function (SravniReviewsEnumsReviewAuthorRoleType) {
    SravniReviewsEnumsReviewAuthorRoleType["All"] = "all";
    SravniReviewsEnumsReviewAuthorRoleType["Users"] = "users";
    SravniReviewsEnumsReviewAuthorRoleType["Moderators"] = "moderators";
    SravniReviewsEnumsReviewAuthorRoleType["Representatives"] = "representatives";
})(SravniReviewsEnumsReviewAuthorRoleType = exports.SravniReviewsEnumsReviewAuthorRoleType || (exports.SravniReviewsEnumsReviewAuthorRoleType = {}));
/** Тип фильтрации отзывов */
var SravniReviewsEnumsReviewFilter;
(function (SravniReviewsEnumsReviewFilter) {
    SravniReviewsEnumsReviewFilter["WithAnswers"] = "withAnswers";
    SravniReviewsEnumsReviewFilter["WithRates"] = "withRates";
    SravniReviewsEnumsReviewFilter["Resolved"] = "resolved";
    SravniReviewsEnumsReviewFilter["RatesRejected"] = "ratesRejected";
    SravniReviewsEnumsReviewFilter["All"] = "all";
})(SravniReviewsEnumsReviewFilter = exports.SravniReviewsEnumsReviewFilter || (exports.SravniReviewsEnumsReviewFilter = {}));
/** Тип сортировки отзывов */
var SravniReviewsEnumsReviewOrder;
(function (SravniReviewsEnumsReviewOrder) {
    SravniReviewsEnumsReviewOrder["ByDate"] = "byDate";
    SravniReviewsEnumsReviewOrder["ByPopularity"] = "byPopularity";
    SravniReviewsEnumsReviewOrder["HighRateFirst"] = "highRateFirst";
    SravniReviewsEnumsReviewOrder["LowRateFirst"] = "lowRateFirst";
    SravniReviewsEnumsReviewOrder["WithAnswers"] = "withAnswers";
    SravniReviewsEnumsReviewOrder["WithRates"] = "withRates";
    SravniReviewsEnumsReviewOrder["Checked"] = "checked";
    SravniReviewsEnumsReviewOrder["Resolved"] = "resolved";
    SravniReviewsEnumsReviewOrder["MostCommented"] = "mostCommented";
    SravniReviewsEnumsReviewOrder["PartnersFirst"] = "partnersFirst";
})(SravniReviewsEnumsReviewOrder = exports.SravniReviewsEnumsReviewOrder || (exports.SravniReviewsEnumsReviewOrder = {}));
/** Тип оценки для фильтрации отзывов */
var SravniReviewsEnumsReviewRate;
(function (SravniReviewsEnumsReviewRate) {
    SravniReviewsEnumsReviewRate["Any"] = "any";
    SravniReviewsEnumsReviewRate["Five"] = "five";
    SravniReviewsEnumsReviewRate["Four"] = "four";
    SravniReviewsEnumsReviewRate["Three"] = "three";
    SravniReviewsEnumsReviewRate["Two"] = "two";
    SravniReviewsEnumsReviewRate["One"] = "one";
    SravniReviewsEnumsReviewRate["Good"] = "good";
    SravniReviewsEnumsReviewRate["Bad"] = "bad";
})(SravniReviewsEnumsReviewRate = exports.SravniReviewsEnumsReviewRate || (exports.SravniReviewsEnumsReviewRate = {}));
/** Статусы проверки оценки отзыва */
var SravniReviewsEnumsReviewRateStatus;
(function (SravniReviewsEnumsReviewRateStatus) {
    SravniReviewsEnumsReviewRateStatus["Unknown"] = "unknown";
    SravniReviewsEnumsReviewRateStatus["RateNotAvailable"] = "rateNotAvailable";
    SravniReviewsEnumsReviewRateStatus["RateChecking"] = "rateChecking";
    SravniReviewsEnumsReviewRateStatus["RateApproved"] = "rateApproved";
    SravniReviewsEnumsReviewRateStatus["RateModified"] = "rateModified";
    SravniReviewsEnumsReviewRateStatus["RateRejected"] = "rateRejected";
})(SravniReviewsEnumsReviewRateStatus = exports.SravniReviewsEnumsReviewRateStatus || (exports.SravniReviewsEnumsReviewRateStatus = {}));
/** статус отзыва */
var SravniReviewsEnumsReviewStatus;
(function (SravniReviewsEnumsReviewStatus) {
    SravniReviewsEnumsReviewStatus["Checking"] = "checking";
    SravniReviewsEnumsReviewStatus["Checked"] = "checked";
    SravniReviewsEnumsReviewStatus["PreModeration"] = "preModeration";
})(SravniReviewsEnumsReviewStatus = exports.SravniReviewsEnumsReviewStatus || (exports.SravniReviewsEnumsReviewStatus = {}));
var SravniReviewsEnumsUserDataStatus;
(function (SravniReviewsEnumsUserDataStatus) {
    SravniReviewsEnumsUserDataStatus["None"] = "none";
    SravniReviewsEnumsUserDataStatus["Requested"] = "requested";
    SravniReviewsEnumsUserDataStatus["Received"] = "received";
    SravniReviewsEnumsUserDataStatus["Approved"] = "approved";
    SravniReviewsEnumsUserDataStatus["Rejected"] = "rejected";
})(SravniReviewsEnumsUserDataStatus = exports.SravniReviewsEnumsUserDataStatus || (exports.SravniReviewsEnumsUserDataStatus = {}));
var SravniReviewsModelsChartsTypeSeries;
(function (SravniReviewsModelsChartsTypeSeries) {
    SravniReviewsModelsChartsTypeSeries["Null"] = "null";
    SravniReviewsModelsChartsTypeSeries["Line"] = "line";
    SravniReviewsModelsChartsTypeSeries["Spline"] = "spline";
    SravniReviewsModelsChartsTypeSeries["Column"] = "column";
    SravniReviewsModelsChartsTypeSeries["Area"] = "area";
    SravniReviewsModelsChartsTypeSeries["Areaspline"] = "areaspline";
    SravniReviewsModelsChartsTypeSeries["Pie"] = "pie";
    SravniReviewsModelsChartsTypeSeries["Arearange"] = "arearange";
    SravniReviewsModelsChartsTypeSeries["Areasplinerange"] = "areasplinerange";
    SravniReviewsModelsChartsTypeSeries["Boxplot"] = "boxplot";
    SravniReviewsModelsChartsTypeSeries["Bubble"] = "bubble";
    SravniReviewsModelsChartsTypeSeries["Columnrange"] = "columnrange";
    SravniReviewsModelsChartsTypeSeries["Errorbar"] = "errorbar";
    SravniReviewsModelsChartsTypeSeries["Funnel"] = "funnel";
    SravniReviewsModelsChartsTypeSeries["Gauge"] = "gauge";
    SravniReviewsModelsChartsTypeSeries["Scatter"] = "scatter";
    SravniReviewsModelsChartsTypeSeries["Waterfall"] = "waterfall";
    SravniReviewsModelsChartsTypeSeries["Bar"] = "bar";
    SravniReviewsModelsChartsTypeSeries["Heatmap"] = "heatmap";
    SravniReviewsModelsChartsTypeSeries["Pyramid"] = "pyramid";
    SravniReviewsModelsChartsTypeSeries["Polygon"] = "polygon";
    SravniReviewsModelsChartsTypeSeries["Treemap"] = "treemap";
    SravniReviewsModelsChartsTypeSeries["Solidgauge"] = "solidgauge";
    SravniReviewsModelsChartsTypeSeries["Bellcurve"] = "bellcurve";
    SravniReviewsModelsChartsTypeSeries["Bullet"] = "bullet";
    SravniReviewsModelsChartsTypeSeries["Histogram"] = "histogram";
    SravniReviewsModelsChartsTypeSeries["Pareto"] = "pareto";
    SravniReviewsModelsChartsTypeSeries["Sankey"] = "sankey";
    SravniReviewsModelsChartsTypeSeries["Scatter3D"] = "scatter3d";
    SravniReviewsModelsChartsTypeSeries["Streamgraph"] = "streamgraph";
    SravniReviewsModelsChartsTypeSeries["Sunburst"] = "sunburst";
    SravniReviewsModelsChartsTypeSeries["Tilemap"] = "tilemap";
    SravniReviewsModelsChartsTypeSeries["Variablepie"] = "variablepie";
    SravniReviewsModelsChartsTypeSeries["Variwide"] = "variwide";
    SravniReviewsModelsChartsTypeSeries["Vector"] = "vector";
    SravniReviewsModelsChartsTypeSeries["Windbarb"] = "windbarb";
    SravniReviewsModelsChartsTypeSeries["Wordcloud"] = "wordcloud";
    SravniReviewsModelsChartsTypeSeries["Xrange"] = "xrange";
})(SravniReviewsModelsChartsTypeSeries = exports.SravniReviewsModelsChartsTypeSeries || (exports.SravniReviewsModelsChartsTypeSeries = {}));
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
class HttpClient {
    constructor(apiConfig = {}) {
        this.baseUrl = '';
        this.securityData = null;
        this.abortControllers = new Map();
        this.customFetch = (...fetchParams) => fetch(...fetchParams);
        this.baseApiParams = {
            credentials: 'same-origin',
            headers: {},
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
        };
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.contentFormatters = {
            [ContentType.Json]: (input) => input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
            [ContentType.Text]: (input) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
            [ContentType.FormData]: (input) => Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(key, property instanceof Blob
                    ? property
                    : typeof property === 'object' && property !== null
                        ? JSON.stringify(property)
                        : `${property}`);
                return formData;
            }, new FormData()),
            [ContentType.UrlEncoded]: (input) => this.toQueryString(input),
        };
        this.createAbortSignal = (cancelToken) => {
            if (this.abortControllers.has(cancelToken)) {
                const abortController = this.abortControllers.get(cancelToken);
                if (abortController) {
                    return abortController.signal;
                }
                return void 0;
            }
            const abortController = new AbortController();
            this.abortControllers.set(cancelToken, abortController);
            return abortController.signal;
        };
        this.abortRequest = (cancelToken) => {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                abortController.abort();
                this.abortControllers.delete(cancelToken);
            }
        };
        this.request = async (_a) => {
            var { body, secure, path, type, query, format, baseUrl, cancelToken } = _a, params = __rest(_a, ["body", "secure", "path", "type", "query", "format", "baseUrl", "cancelToken"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const queryString = query && this.toQueryString(query);
            const payloadFormatter = this.contentFormatters[type || ContentType.Json];
            const responseFormat = format || requestParams.format;
            return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (requestParams.headers || {})), (type && type !== ContentType.FormData ? { 'Content-Type': type } : {})), signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null, body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body) })).then(async (response) => {
                const r = response.clone();
                r.data = null;
                r.error = null;
                const data = !responseFormat
                    ? r
                    : await response[responseFormat]()
                        .then(data => {
                        if (r.ok) {
                            r.data = data;
                        }
                        else {
                            r.error = data;
                        }
                        return r;
                    })
                        .catch(e => {
                        r.error = e;
                        return r;
                    });
                if (cancelToken) {
                    this.abortControllers.delete(cancelToken);
                }
                if (!response.ok)
                    throw data;
                return data;
            });
        };
        Object.assign(this, apiConfig);
    }
    encodeQueryParam(key, value) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }
    addQueryParam(query, key) {
        return this.encodeQueryParam(key, query[key]);
    }
    addArrayQueryParam(query, key) {
        const value = query[key];
        return value.map((v) => this.encodeQueryParam(key, v)).join('&');
    }
    toQueryString(rawQuery) {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter(key => 'undefined' !== typeof query[key]);
        return keys
            .map(key => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
            .join('&');
    }
    addQueryParams(rawQuery) {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.baseApiParams), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.baseApiParams.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Sravni.Reviews.Service 2.0
 * @version 2.0
 *
 * Микросервис отзывов
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v2 = {
            /**
             * No description
             *
             * @tags Attachment
             * @name AttachmentUploadCreate
             * @summary Загружает файл
             * @request POST:/v2/attachment/upload
             * @secure
             */
            attachmentUploadCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/attachment/upload`, method: 'POST', body: data, secure: true, type: ContentType.FormData, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Attachment
             * @name AttachmentDetail
             * @summary Возвращает метаинформацию о файле по его идентификатору
             * @request GET:/v2/attachment/{id}
             */
            attachmentDetail: (id, params = {}) => this.request(Object.assign({ path: `/v2/attachment/${id}`, method: 'GET', format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Attachment
             * @name AttachmentReviewDetail
             * @summary Получает приватный файл по id отзыва и id файла
             * @request GET:/v2/attachment/{id}/review/{reviewId}
             * @secure
             */
            attachmentReviewDetail: (id, reviewId, params = {}) => this.request(Object.assign({ path: `/v2/attachment/${id}/review/${reviewId}`, method: 'GET', secure: true }, params)),
            /**
             * No description
             *
             * @tags Attachment
             * @name AttachmentReviewWithContentDetail
             * @summary Получает метаинформацию о файле
             * @request GET:/v2/attachment/{id}/review/{reviewId}/with-content
             * @secure
             */
            attachmentReviewWithContentDetail: (id, reviewId, params = {}) => this.request(Object.assign({ path: `/v2/attachment/${id}/review/${reviewId}/with-content`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AutoModeration
             * @name AutoModerationSettingsCreate
             * @summary Создание новой настройки автомодерации
             * @request POST:/v2/auto-moderation/settings
             * @secure
             */
            autoModerationSettingsCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/auto-moderation/settings`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AutoModeration
             * @name AutoModerationSettingsList
             * @summary Получение текущей настройки автомодерации
             * @request GET:/v2/auto-moderation/settings
             * @secure
             */
            autoModerationSettingsList: (params = {}) => this.request(Object.assign({ path: `/v2/auto-moderation/settings`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AutoModeration
             * @name AutoModerationProcessReviewCreate
             * @summary Автомодерация отзыва
             * @request POST:/v2/auto-moderation/process-review
             * @secure
             */
            autoModerationProcessReviewCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/auto-moderation/process-review`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags AutoModeration
             * @name AutoModerationHistoryList
             * @summary Получение списка истории автомодерации
             * @request GET:/v2/auto-moderation/history
             * @secure
             */
            autoModerationHistoryList: (query, params = {}) => this.request(Object.assign({ path: `/v2/auto-moderation/history`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClientToOrganization
             * @name OrganizationTokensList
             * @summary Возвращает организации по фильтру
             * @request GET:/v2/organization-tokens
             * @secure
             */
            organizationTokensList: (query, params = {}) => this.request(Object.assign({ path: `/v2/organization-tokens`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClientToOrganization
             * @name AllOrganizationTokensList
             * @summary Возвращает все организации
             * @request GET:/v2/all-organization-tokens
             * @secure
             */
            allOrganizationTokensList: (params = {}) => this.request(Object.assign({ path: `/v2/all-organization-tokens`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ClientToOrganization
             * @name OrganizationTokenCreate
             * @summary Добавляет организацию
             * @request POST:/v2/organization-token
             * @secure
             */
            organizationTokenCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/organization-token`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags ClientToOrganization
             * @name OrganizationTokensUpdate
             * @summary Обновляет данные организации
             * @request PUT:/v2/organization-tokens/{id}
             * @secure
             */
            organizationTokensUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/v2/organization-tokens/${id}`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags ClientToOrganization
             * @name OrganizationTokensDelete
             * @summary Удаляет организацию
             * @request DELETE:/v2/organization-tokens/{id}
             * @secure
             */
            organizationTokensDelete: (id, params = {}) => this.request(Object.assign({ path: `/v2/organization-tokens/${id}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags ClientToOrganization
             * @name OrganizationTokenPartialUpdate
             * @summary Восстанавливает организацию
             * @request PATCH:/v2/organization-token/{id}
             * @secure
             */
            organizationTokenPartialUpdate: (id, params = {}) => this.request(Object.assign({ path: `/v2/organization-token/${id}`, method: 'PATCH', secure: true }, params)),
            /**
             * No description
             *
             * @tags Comments
             * @name CommentDelete
             * @summary Удаляет комментарий по Id
             * @request DELETE:/v2/comment/{id}
             * @secure
             */
            commentDelete: (id, params = {}) => this.request(Object.assign({ path: `/v2/comment/${id}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Comments
             * @name CommentsList
             * @summary Возвращает комментарии к отзыву
             * @request GET:/v2/comments
             */
            commentsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/comments`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Comments
             * @name CommentCreate
             * @summary Добавляет комментарий
             * @request POST:/v2/comment
             * @secure
             */
            commentCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/comment`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Comments
             * @name CommentUpdate
             * @summary Обновляет комментарий
             * @request PUT:/v2/comment
             * @secure
             */
            commentUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/comment`, method: 'PUT', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Comments
             * @name CommentUpdateAuthorNameCreate
             * @summary Обновляет имя и фамилию в комментарии для представителя организации
             * @request POST:/v2/comment/update-author-name
             * @secure
             */
            commentUpdateAuthorNameCreate: (query, params = {}) => this.request(Object.assign({ path: `/v2/comment/update-author-name`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ExternalApi
             * @name ExternalApiWithUserDataReviewsList
             * @request GET:/v2/external-api/with-user-data/reviews
             * @secure
             */
            externalApiWithUserDataReviewsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/external-api/with-user-data/reviews`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ExternalApi
             * @name ExternalApiWithUserDataReviewsSortedByEventList
             * @request GET:/v2/external-api/with-user-data/reviews-sorted-by-event
             * @secure
             */
            externalApiWithUserDataReviewsSortedByEventList: (query, params = {}) => this.request(Object.assign({ path: `/v2/external-api/with-user-data/reviews-sorted-by-event`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ExternalApi
             * @name ExternalApiReviewsList
             * @request GET:/v2/external-api/reviews
             * @secure
             */
            externalApiReviewsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/external-api/reviews`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ExternalApi
             * @name ExternalApiReviewsSortedByEventList
             * @request GET:/v2/external-api/reviews-sorted-by-event
             * @secure
             */
            externalApiReviewsSortedByEventList: (query, params = {}) => this.request(Object.assign({ path: `/v2/external-api/reviews-sorted-by-event`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name BackofficeReviewsList
             * @summary Возвращает отзывы о компании
             * @request GET:/v2/backoffice-reviews
             */
            backofficeReviewsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/backoffice-reviews`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReviewNoteDetail
             * @summary Возвращает данные о заметках к отзыву
             * @request GET:/v2/review-note/{id}
             */
            reviewNoteDetail: (id, params = {}) => this.request(Object.assign({ path: `/v2/review-note/${id}`, method: 'GET', format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReviewNoteUpdate
             * @summary Обновляет информацию о заметках к отзыву
             * @request PUT:/v2/review-note/{id}
             */
            reviewNoteUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/v2/review-note/${id}`, method: 'PUT', body: data, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReportsBackofficeReviewsContentList
             * @summary Возвращает отзывы о компании для выгрузки в CSV
             * @request GET:/v2/reports/backoffice-reviews-content
             * @secure
             */
            reportsBackofficeReviewsContentList: (query, params = {}) => this.request(Object.assign({ path: `/v2/reports/backoffice-reviews-content`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewPartialUpdate
             * @summary Восстанавливает отзывы по Id
             * @request PATCH:/v2/manage-review
             * @secure
             */
            manageReviewPartialUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review`, method: 'PATCH', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageCommentPartialUpdate
             * @summary Восстанавливает комментария по Id
             * @request PATCH:/v2/manage-comment
             * @secure
             */
            manageCommentPartialUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-comment`, method: 'PATCH', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewRequireDocumentsUpdate
             * @summary Запрашивает явно доп. инфо
             * @request PUT:/v2/manage-review/require-documents
             * @secure
             */
            manageReviewRequireDocumentsUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/require-documents`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReviewRequireDocumentsUpdate
             * @summary Запрашивает явно доп. инфо
             * @request PUT:/v2/review/require-documents
             * @secure
             */
            reviewRequireDocumentsUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review/require-documents`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewApproveDocumentsUpdate
             * @summary Аппрувит доп. инфо
             * @request PUT:/v2/manage-review/approve-documents
             * @secure
             */
            manageReviewApproveDocumentsUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/approve-documents`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReviewApproveDocumentsUpdate
             * @summary Аппрувит доп. инфо
             * @request PUT:/v2/review/approve-documents
             * @secure
             */
            reviewApproveDocumentsUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review/approve-documents`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewApproveRatingUpdate
             * @summary Аппрувит рейтинг отзыва по Id
             * @request PUT:/v2/manage-review/approve-rating
             * @secure
             */
            manageReviewApproveRatingUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/approve-rating`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReviewApproveRatingUpdate
             * @summary Аппрувит рейтинг отзыва по Id
             * @request PUT:/v2/review/approve-rating
             * @secure
             */
            reviewApproveRatingUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review/approve-rating`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewCheckUpdate
             * @summary Помечает отзыв проверенным/не проверенным
             * @request PUT:/v2/manage-review/check
             * @secure
             */
            manageReviewCheckUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/check`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReviewCheckUpdate
             * @summary Помечает отзыв проверенным/не проверенным
             * @request PUT:/v2/review/check
             * @secure
             */
            reviewCheckUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review/check`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewCompanyResponseUpdate
             * @summary Проставляет/убирает официальный ответ компании
             * @request PUT:/v2/manage-review/company-response
             * @secure
             */
            manageReviewCompanyResponseUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/company-response`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ReviewCompanyResponseUpdate
             * @summary Проставляет/убирает официальный ответ компании
             * @request PUT:/v2/review/company-response
             * @secure
             */
            reviewCompanyResponseUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review/company-response`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageCommentCheckUpdate
             * @summary Помечает комментарий проверенным/не проверенным
             * @request PUT:/v2/manage-comment/check
             * @secure
             */
            manageCommentCheckUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-comment/check`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name CommentCheckUpdate
             * @summary Помечает комментарий проверенным/не проверенным
             * @request PUT:/v2/comment/check
             * @secure
             */
            commentCheckUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/comment/check`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewFollowUpCreate
             * @summary Ставит отзыв на контроль
             * @request POST:/v2/manage-review/follow-up
             * @secure
             */
            manageReviewFollowUpCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/follow-up`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewFollowUpDelete
             * @summary Убирает отзыв с контроля
             * @request DELETE:/v2/manage-review/follow-up/{id}
             * @secure
             */
            manageReviewFollowUpDelete: (id, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/follow-up/${id}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewEmailsOfFollowupsUsersList
             * @summary Возвращает мыльники всех фолловаперов
             * @request GET:/v2/manage-review/emails-of-followups-users
             * @secure
             */
            manageReviewEmailsOfFollowupsUsersList: (params = {}) => this.request(Object.assign({ path: `/v2/manage-review/emails-of-followups-users`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name StatsBusinessList
             * @summary Получает данные для графиков статистики по отзывам
             * @request GET:/v2/stats/business
             * @secure
             */
            statsBusinessList: (query, params = {}) => this.request(Object.assign({ path: `/v2/stats/business`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name StatsRatesList
             * @summary Получает данные для графиков статистики по оценкам в отзывах
             * @request GET:/v2/stats/rates
             * @secure
             */
            statsRatesList: (query, params = {}) => this.request(Object.assign({ path: `/v2/stats/rates`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name StatsActivityList
             * @summary Получает данные для графиков статистики по отзывам
             * @request GET:/v2/stats/activity
             * @secure
             */
            statsActivityList: (query, params = {}) => this.request(Object.assign({ path: `/v2/stats/activity`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name StatsRawReviewList
             * @summary Получает данные для графиков статистики по необработанным отзывам
             * @request GET:/v2/stats/raw-review
             * @secure
             */
            statsRawReviewList: (query, params = {}) => this.request(Object.assign({ path: `/v2/stats/raw-review`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name StatsActivityReviewDetail
             * @summary Получает данные для событий по отзыву
             * @request GET:/v2/stats/activity/review/{id}
             * @secure
             */
            statsActivityReviewDetail: (id, params = {}) => this.request(Object.assign({ path: `/v2/stats/activity/review/${id}`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name BackofficeCommentsList
             * @summary Возвращает отзывы о компании
             * @request GET:/v2/backoffice-comments
             * @secure
             */
            backofficeCommentsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/backoffice-comments`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ContentModerationReviewPartialUpdate
             * @summary Удаляет/выставляет премодерацию отзыва по Id
             * @request PATCH:/v2/content/{id}/moderation/review/{approve}
             * @secure
             */
            contentModerationReviewPartialUpdate: (id, approve, params = {}) => this.request(Object.assign({ path: `/v2/content/${id}/moderation/review/${approve}`, method: 'PATCH', secure: true }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ContentModerationCommentPartialUpdate
             * @summary Удаляет/выставляет премодерацию комментария по Id
             * @request PATCH:/v2/content/{id}/moderation/comment/{approve}
             * @secure
             */
            contentModerationCommentPartialUpdate: (id, approve, params = {}) => this.request(Object.assign({ path: `/v2/content/${id}/moderation/comment/${approve}`, method: 'PATCH', secure: true }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewImportCreate
             * @summary Импортирует новый отзыв
             * @request POST:/v2/manage-review/import
             * @secure
             */
            manageReviewImportCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/import`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageReviewBulkImportCreate
             * @summary Импортирует отзывы из файла .xlsx. Добавляет/обновляет отзывы по ExternalId
             * @request POST:/v2/manage-review/bulk-import
             * @secure
             */
            manageReviewBulkImportCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-review/bulk-import`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageUsersBlocksList
             * @summary Список блокировок пользователей
             * @request GET:/v2/manage-users/blocks
             * @secure
             */
            manageUsersBlocksList: (query, params = {}) => this.request(Object.assign({ path: `/v2/manage-users/blocks`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageUsersBlockCreate
             * @summary Блокирует пользователя
             * @request POST:/v2/manage-users/{userId}/block
             * @secure
             */
            manageUsersBlockCreate: (_a, params) => {
                var { userId } = _a, query = __rest(_a, ["userId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/manage-users/${userId}/block`, method: 'POST', query: query, secure: true }, params));
            },
            /**
             * No description
             *
             * @tags Management
             * @name ManageUsersUnblockUpdate
             * @summary Разблокирует пользователя
             * @request PUT:/v2/manage-users/{userId}/unblock
             * @secure
             */
            manageUsersUnblockUpdate: (userId, params = {}) => this.request(Object.assign({ path: `/v2/manage-users/${userId}/unblock`, method: 'PUT', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageUsersInfoList
             * @summary Возвращает информацию о пользователе
             * @request GET:/v2/manage-users/info
             * @secure
             */
            manageUsersInfoList: (params = {}) => this.request(Object.assign({ path: `/v2/manage-users/info`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagList
             * @summary Возвращает теги по заданным параметрам
             * @request GET:/v2/manage-tag
             */
            manageTagList: (query, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagCreate
             * @summary Добавляет тег
             * @request POST:/v2/manage-tag
             * @secure
             */
            manageTagCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagProductTagList
             * @summary Возвращает продуктовые теги
             * @request GET:/v2/manage-tag/product-tag
             * @secure
             */
            manageTagProductTagList: (query, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/product-tag`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagProductTagCreate
             * @summary Добавляет связь между тегом и продуктовым тегом
             * @request POST:/v2/manage-tag/product-tag
             * @secure
             */
            manageTagProductTagCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/product-tag`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagProductTagDelete
             * @summary Удаляет связь тега и продуктового тега
             * @request DELETE:/v2/manage-tag/product-tag
             * @secure
             */
            manageTagProductTagDelete: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/product-tag`, method: 'DELETE', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagUpdate
             * @summary Обновляет данные тега
             * @request PUT:/v2/manage-tag/{id}
             * @secure
             */
            manageTagUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/${id}`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagDelete
             * @summary Удаляет тег
             * @request DELETE:/v2/manage-tag/{id}
             * @secure
             */
            manageTagDelete: (id, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/${id}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagPartialUpdate
             * @summary Восстанавливает тег
             * @request PATCH:/v2/manage-tag/{id}
             * @secure
             */
            manageTagPartialUpdate: (id, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/${id}`, method: 'PATCH', secure: true }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagReviewCreate
             * @summary Создает связь тега и отзыва
             * @request POST:/v2/manage-tag/review
             * @secure
             */
            manageTagReviewCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/review`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagReviewDelete
             * @summary Удаляет связь тега и отзыва
             * @request DELETE:/v2/manage-tag/review
             * @secure
             */
            manageTagReviewDelete: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/review`, method: 'DELETE', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ManageTagReviewUpdate
             * @summary Редактирует связь тега и отзыва
             * @request PUT:/v2/manage-tag/review
             * @secure
             */
            manageTagReviewUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/manage-tag/review`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name BackofficeRatingList
             * @summary Возвращает рейтинг для админки отзывов в пагинированном виде
             * @request GET:/v2/backoffice-rating
             * @secure
             */
            backofficeRatingList: (query, params = {}) => this.request(Object.assign({ path: `/v2/backoffice-rating`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ModeratorToOrganizationsList
             * @summary Вовзращает список связей компании-модератор
             * @request GET:/v2/moderator-to-organizations
             * @secure
             */
            moderatorToOrganizationsList: (params = {}) => this.request(Object.assign({ path: `/v2/moderator-to-organizations`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ModeratorToOrganizationsCreate
             * @summary Создаёт или обновляет связь компании-модератор
             * @request POST:/v2/moderator-to-organizations
             * @secure
             */
            moderatorToOrganizationsCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/moderator-to-organizations`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ModeratorToOrganizationsDelete
             * @summary Удаляет связь компании-модератор
             * @request DELETE:/v2/moderator-to-organizations
             * @secure
             */
            moderatorToOrganizationsDelete: (query, params = {}) => this.request(Object.assign({ path: `/v2/moderator-to-organizations`, method: 'DELETE', query: query, secure: true }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name ModeratorsInfoList
             * @summary Возвращает данные о модераторах
             * @request GET:/v2/moderators/info
             * @secure
             */
            moderatorsInfoList: (params = {}) => this.request(Object.assign({ path: `/v2/moderators/info`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Management
             * @name DropRedisCacheList
             * @request GET:/v2/drop-redis-cache
             */
            dropRedisCacheList: (query, params = {}) => this.request(Object.assign({ path: `/v2/drop-redis-cache`, method: 'GET', query: query }, params)),
            /**
             * No description
             *
             * @tags Ratings
             * @name RatingList
             * @summary Возвращает рейтинг
             * @request GET:/v2/rating
             */
            ratingList: (query, params = {}) => this.request(Object.assign({ path: `/v2/rating`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Ratings
             * @name AggregatedRatingList
             * @summary Возвращает топ рейтинг по услугам
             * @request GET:/v2/aggregated-rating
             */
            aggregatedRatingList: (query, params = {}) => this.request(Object.assign({ path: `/v2/aggregated-rating`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Ratings
             * @name ReviewStatsList
             * @summary Возвращает статистику по оценкам в отзывах
             * @request GET:/v2/review-stats
             */
            reviewStatsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/review-stats`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Ratings
             * @name ReviewSeoStatsList
             * @summary Возвращает статистику по оценкам в отзывах
             * @request GET:/v2/review-seo-stats
             */
            reviewSeoStatsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/review-seo-stats`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Ratings
             * @name RatingStatsList
             * @summary Возвращает статистику по оценкам в отзывах в организации
             * @request GET:/v2/rating-stats
             */
            ratingStatsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/rating-stats`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Ratings
             * @name SravniCustomersRatingList
             * @summary Возвращает статистику по оценкам в отзывах в организации
             * @request GET:/v2/sravni-customers-rating
             */
            sravniCustomersRatingList: (query, params = {}) => this.request(Object.assign({ path: `/v2/sravni-customers-rating`, method: 'GET', query: query, format: 'json' }, params)),
            /**
         * No description
         *
         * @tags Ratings
         * @name RatingForInterestingOffersList
         * @summary Возвращает статистику по оценкам в отзывах в конкретных продуктах
        ИСПОЛЬЗУЕТСЯ ТОЛЬКО БЛОКОМ ИП НА ФРОНТАХ ОТЗЫВОВ
         * @request GET:/v2/rating-for-interesting-offers
         */
            ratingForInterestingOffersList: (query, params = {}) => this.request(Object.assign({ path: `/v2/rating-for-interesting-offers`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Representatives
             * @name OrganizationUsersDetail
             * @summary Возвращает главного представителя конкретной компании
             * @request GET:/v2/organization-users/{organizationId}
             */
            organizationUsersDetail: (organizationId, params = {}) => this.request(Object.assign({ path: `/v2/organization-users/${organizationId}`, method: 'GET', format: 'json' }, params)),
            /**
         * No description
         *
         * @tags Representatives
         * @name OrganizationUsersList
         * @summary Возвращает пользователей компаний
        РУЧКА ДЛЯ БЭКОФФИСА
         * @request GET:/v2/organization-users
         * @secure
         */
            organizationUsersList: (query, params = {}) => this.request(Object.assign({ path: `/v2/organization-users`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
         * No description
         *
         * @tags Representatives
         * @name OrganizationUsersCreate
         * @summary Добавляет привязку пользователя
        РУЧКА ДЛЯ БЭКОФФИСА
         * @request POST:/v2/organization-users
         * @secure
         */
            organizationUsersCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/organization-users`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
         * No description
         *
         * @tags Representatives
         * @name OrganizationUsersUpdate
         * @summary Изменяет привязку пользователя
        РУЧКА ДЛЯ БЭКОФФИСА
         * @request PUT:/v2/organization-users/{id}
         * @secure
         */
            organizationUsersUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/v2/organization-users/${id}`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
         * No description
         *
         * @tags Representatives
         * @name OrganizationUsersDelete
         * @summary Удаляет привязку пользователя
        РУЧКА ДЛЯ БЭКОФФИСА
         * @request DELETE:/v2/organization-users/{id}
         * @secure
         */
            organizationUsersDelete: (id, params = {}) => this.request(Object.assign({ path: `/v2/organization-users/${id}`, method: 'DELETE', secure: true }, params)),
            /**
         * No description
         *
         * @tags Representatives
         * @name OrganizationUsersPartialUpdate
         * @summary Восстанавливает привязку пользователя по Id
        РУЧКА ДЛЯ БЭКОФФИСА
         * @request PATCH:/v2/organization-users/{id}
         * @secure
         */
            organizationUsersPartialUpdate: (id, params = {}) => this.request(Object.assign({ path: `/v2/organization-users/${id}`, method: 'PATCH', secure: true }, params)),
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationDetail
             * @summary Возвращает информацию о рейтингах с разбивкой по продуктам за выбранный период
             * @request GET:/v2/reputation/{organizationId}
             */
            reputationDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reputation/${organizationId}`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationPositionDetail
             * @summary Возвращает текущую позицию организации в топе клиентского рейтинга
             * @request GET:/v2/reputation/{organizationId}/position
             */
            reputationPositionDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reputation/${organizationId}/position`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationAverageRatingDetail
             * @summary Возвращает средний рейтинг за последний месяц
             * @request GET:/v2/reputation/{organizationId}/average-rating
             */
            reputationAverageRatingDetail: (organizationId, params = {}) => this.request(Object.assign({ path: `/v2/reputation/${organizationId}/average-rating`, method: 'GET', format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationStatsDetail
             * @summary Возвращает осносную статистику для указанной организации за период
             * @request GET:/v2/reputation/{organizationId}/stats
             */
            reputationStatsDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reputation/${organizationId}/stats`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationStatsPerformanceOverviewDetail
             * @summary Возвращает performance overview для указанной организации
             * @request GET:/v2/reputation/{organizationId}/stats/performance-overview
             */
            reputationStatsPerformanceOverviewDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reputation/${organizationId}/stats/performance-overview`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationStatsCompanyResponseDetail
             * @summary Возвращает статистику по ответам компании
             * @request GET:/v2/reputation/{organizationId}/stats/company-response
             */
            reputationStatsCompanyResponseDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reputation/${organizationId}/stats/company-response`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationStatsDetailedDetail
             * @summary Возвращает детальную статистику с разбивкой на указанные периоды
             * @request GET:/v2/reputation/{organizationId}/stats/detailed
             */
            reputationStatsDetailedDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reputation/${organizationId}/stats/detailed`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reputation
             * @name ReputationStatsCsvDetail
             * @summary Возвращает csv контент
             * @request GET:/v2/reputation/{organizationId}/stats/csv
             */
            reputationStatsCsvDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reputation/${organizationId}/stats/csv`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemesList
             * @summary Возвращает список конфигурационных схем для дополнительной информации
             * @request GET:/v2/reviews/additional-info/schemes
             */
            reviewsAdditionalInfoSchemesList: (query, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/schemes`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemeList
             * @summary Возвращает схему по заданным параметрам
             * @request GET:/v2/reviews/additional-info/scheme
             */
            reviewsAdditionalInfoSchemeList: (query, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/scheme`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemeCreate
             * @summary Создает схему дополнительной информации
             * @request POST:/v2/reviews/additional-info/scheme
             */
            reviewsAdditionalInfoSchemeCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/scheme`, method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemesDetail
             * @summary Возвращает схему дополнительной информации по идентификатору
             * @request GET:/v2/reviews/additional-info/schemes/{id}
             */
            reviewsAdditionalInfoSchemesDetail: (id, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/schemes/${id}`, method: 'GET', format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemesUpdate
             * @summary Обновляет уже имеющуюся схему дополнительной информации
             * @request PUT:/v2/reviews/additional-info/schemes/{id}
             */
            reviewsAdditionalInfoSchemesUpdate: (id, data, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/schemes/${id}`, method: 'PUT', body: data, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemesDelete
             * @summary Удаляет схему дополнительной информации
             * @request DELETE:/v2/reviews/additional-info/schemes/{id}
             */
            reviewsAdditionalInfoSchemesDelete: (id, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/schemes/${id}`, method: 'DELETE' }, params)),
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemesPartialUpdate
             * @summary Восстанавливает ранее удаленную схему дополнительной информации
             * @request PATCH:/v2/reviews/additional-info/schemes/{id}
             */
            reviewsAdditionalInfoSchemesPartialUpdate: (id, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/schemes/${id}`, method: 'PATCH' }, params)),
            /**
             * No description
             *
             * @tags ReviewAdditionalInfo
             * @name ReviewsAdditionalInfoSchemesPublishPartialUpdate
             * @summary Публикует схему конфигурации дополнительной информации
             * @request PATCH:/v2/reviews/additional-info/schemes/{id}/publish
             */
            reviewsAdditionalInfoSchemesPublishPartialUpdate: (id, params = {}) => this.request(Object.assign({ path: `/v2/reviews/additional-info/schemes/${id}/publish`, method: 'PATCH' }, params)),
            /**
         * No description
         *
         * @tags Reviews
         * @name ReviewsList
         * @summary Возвращает отзывы о компании.
        Для фильтра с хорошими оценками (ReviewRate.Good - 3,4,5) добавляется средний рейтинг в поле `AverageRating` для сео компонентов
         * @request GET:/v2/reviews
         */
            reviewsList: (_a, params) => {
                var { fingerPrint } = _a, query = __rest(_a, ["fingerPrint"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reviews`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reviews
             * @name HeadV2
             * @summary Возвращает статистику по оценкам в отзывах
             * @request HEAD:/v2/reviews
             */
            headV2: (query, params = {}) => this.request(Object.assign({ path: `/v2/reviews`, method: 'HEAD', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewDetail
             * @summary Возвращает отзыв
             * @request GET:/v2/review/{id}/{fingerPrint}
             */
            reviewDetail: (id, fingerPrint, params = {}) => this.request(Object.assign({ path: `/v2/review/${id}/${fingerPrint}`, method: 'GET', format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewsTagsDetail
             * @summary Возвращает количество позитивных/негативных тегов организации
             * @request GET:/v2/reviews/{organizationId}/tags
             */
            reviewsTagsDetail: (_a, params) => {
                var { organizationId } = _a, query = __rest(_a, ["organizationId"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/reviews/${organizationId}/tags`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewCreate
             * @summary Добавляет новый отзыв
             * @request POST:/v2/review
             */
            reviewCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review`, method: 'POST', body: data, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewUpdate
             * @summary Обновляет отзыв
             * @request PUT:/v2/review
             * @secure
             */
            reviewUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewPersonalDataUpdate
             * @summary Обновляет персональные данные отзыва
             * @request PUT:/v2/review/personal-data
             * @secure
             */
            reviewPersonalDataUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review/personal-data`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewDelete
             * @summary Удаляет отзыв/комментарий по Id
             * @request DELETE:/v2/review/{id}
             */
            reviewDelete: (id, params = {}) => this.request(Object.assign({ path: `/v2/review/${id}`, method: 'DELETE' }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewResolveUpdate
             * @summary Изменение статуса проблемы , описанной в отзыве
             * @request PUT:/v2/review/resolve
             * @secure
             */
            reviewResolveUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/review/resolve`, method: 'PUT', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name SettingsFilterDetail
             * @summary Настройки фильтра
             * @request GET:/v2/settings/filter/{objectType}
             */
            settingsFilterDetail: (_a, params) => {
                var { objectType } = _a, query = __rest(_a, ["objectType"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/settings/filter/${objectType}`, method: 'GET', query: query, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewsSeoList
             * @summary Возвращает данные для seo.
             * @request GET:/v2/reviews/seo
             */
            reviewsSeoList: (query, params = {}) => this.request(Object.assign({ path: `/v2/reviews/seo`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewsSeoForSitemapList
             * @summary Возвращает данные для seo карты сайта.
             * @request GET:/v2/reviews/seo/for-sitemap
             */
            reviewsSeoForSitemapList: (query, params = {}) => this.request(Object.assign({ path: `/v2/reviews/seo/for-sitemap`, method: 'GET', query: query, format: 'json' }, params)),
            /**
         * No description
         *
         * @tags Reviews
         * @name ReviewsCountByOrganizationsList
         * @summary Возвращает информацию по количеству разрешённых для публикации отзывов в разрезе организации
        В том числе и с отклонённым/незачтённым рейтингом
        Кеш - час
         * @request GET:/v2/reviews/count-by-organizations
         */
            reviewsCountByOrganizationsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/reviews/count-by-organizations`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Reviews
             * @name ReviewsAggregatedReviewsCountList
             * @summary Возвращает информацию по оценкам компании. Если не указывать organizationId - вернет по всем организациям.
             * @request GET:/v2/reviews/aggregated-reviews-count
             */
            reviewsAggregatedReviewsCountList: (query, params = {}) => this.request(Object.assign({ path: `/v2/reviews/aggregated-reviews-count`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Sitemap
             * @name GetSiteMapIndexList
             * @summary Берёт индекс сайтмапа
             * @request GET:/v2/get-site-map-index
             */
            getSiteMapIndexList: (params = {}) => this.request(Object.assign({ path: `/v2/get-site-map-index`, method: 'GET' }, params)),
            /**
             * No description
             *
             * @tags Sitemap
             * @name GetSiteMapDetail
             * @summary Берёт сайтмап по дате/алиасу организации.
             * @request GET:/v2/get-site-map/{organizationAlias}/{date}
             */
            getSiteMapDetail: (organizationAlias, date, params = {}) => this.request(Object.assign({ path: `/v2/get-site-map/${organizationAlias}/${date}`, method: 'GET' }, params)),
            /**
             * No description
             *
             * @tags Sitemap
             * @name GetSiteMapDetail2
             * @summary Берёт сайтмап по алиасу организации. Берёт за текущий день
             * @request GET:/v2/get-site-map/{organizationAlias}
             * @originalName getSiteMapDetail
             * @duplicate
             */
            getSiteMapDetail2: (organizationAlias, params = {}) => this.request(Object.assign({ path: `/v2/get-site-map/${organizationAlias}`, method: 'GET' }, params)),
            /**
             * No description
             *
             * @tags Squeeze
             * @name SqueezeReviewsSqueezesList
             * @summary Выжимки из текстов, которые создала нейросеть
             * @request GET:/v2/squeeze/reviews-squeezes
             */
            squeezeReviewsSqueezesList: (query, params = {}) => this.request(Object.assign({ path: `/v2/squeeze/reviews-squeezes`, method: 'GET', query: query, format: 'json' }, params)),
            /**
         * No description
         *
         * @tags Squeeze
         * @name SqueezeWhitelistList
         * @summary Выжимки из текстов, с джоином на список вайтлистов/блэклистов
        Используются бэкоффисом
         * @request GET:/v2/squeeze/whitelist
         * @secure
         */
            squeezeWhitelistList: (query, params = {}) => this.request(Object.assign({ path: `/v2/squeeze/whitelist`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
         * No description
         *
         * @tags Squeeze
         * @name SqueezeWhitelistCreate
         * @summary Добавляет или обновляет выжимку в белый список
        Используются бэкоффисом
         * @request POST:/v2/squeeze/whitelist
         * @secure
         */
            squeezeWhitelistCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/squeeze/whitelist`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
         * No description
         *
         * @tags Squeeze
         * @name SqueezeWhitelistDelete
         * @summary Удаляет выжимку из белого списка
        Используются бэкоффисом
         * @request DELETE:/v2/squeeze/whitelist
         * @secure
         */
            squeezeWhitelistDelete: (query, params = {}) => this.request(Object.assign({ path: `/v2/squeeze/whitelist`, method: 'DELETE', query: query, secure: true }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name TagsList
             * @summary Возвращает теги по заданным параметрам
             * @request GET:/v2/tags
             */
            tagsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/tags`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name TagProductTagList
             * @summary Возвращает продуктовые теги
             * @request GET:/v2/tag/product-tag
             */
            tagProductTagList: (query, params = {}) => this.request(Object.assign({ path: `/v2/tag/product-tag`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name TagProductTagCreate
             * @summary Добавляет связь между тегом и продуктовым тегом
             * @request POST:/v2/tag/product-tag
             * @secure
             */
            tagProductTagCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/tag/product-tag`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name TagProductTagDelete
             * @summary Удаляет связь тега и продуктового тега
             * @request DELETE:/v2/tag/product-tag
             * @secure
             */
            tagProductTagDelete: (data, params = {}) => this.request(Object.assign({ path: `/v2/tag/product-tag`, method: 'DELETE', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name PostV2
             * @summary Добавляет тег
             * @request POST:/v2/tag
             * @secure
             */
            postV2: (data, params = {}) => this.request(Object.assign({ path: `/v2/tag`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name PutV2
             * @summary Обновляет данные тега
             * @request PUT:/v2/tag/{id}
             * @secure
             */
            putV2: (id, data, params = {}) => this.request(Object.assign({ path: `/v2/tag/${id}`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name DeleteV2
             * @summary Удаляет тег
             * @request DELETE:/v2/tag/{id}
             * @secure
             */
            deleteV2: (id, params = {}) => this.request(Object.assign({ path: `/v2/tag/${id}`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name PatchV2
             * @summary Восстанавливает тег
             * @request PATCH:/v2/tag/{id}
             * @secure
             */
            patchV2: (id, params = {}) => this.request(Object.assign({ path: `/v2/tag/${id}`, method: 'PATCH', secure: true }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name TagReviewCreate
             * @summary Создает связь тега и отзыва
             * @request POST:/v2/tag/review
             * @secure
             */
            tagReviewCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/tag/review`, method: 'POST', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name TagReviewDelete
             * @summary Удаляет связь тега и отзыва
             * @request DELETE:/v2/tag/review
             * @secure
             */
            tagReviewDelete: (data, params = {}) => this.request(Object.assign({ path: `/v2/tag/review`, method: 'DELETE', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags Tags
             * @name TagReviewUpdate
             * @summary Редактирует связь тега и отзыва
             * @request PUT:/v2/tag/review
             * @secure
             */
            tagReviewUpdate: (data, params = {}) => this.request(Object.assign({ path: `/v2/tag/review`, method: 'PUT', body: data, secure: true, type: ContentType.Json }, params)),
            /**
             * No description
             *
             * @tags User
             * @name ActivityDetail
             * @summary Получает контент пользователя
             * @request GET:/v2/activity/{id}
             * @secure
             */
            activityDetail: (_a, params) => {
                var { id } = _a, query = __rest(_a, ["id"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/activity/${id}`, method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
         * No description
         *
         * @tags User
         * @name ActivityByServiceDetail
         * @summary Получает контент пользователя - потребитель наш внутренний сервис.
        Предпологается что проверка пользователя идёт на стороне этого сервиса.
        Ручка необходима для решения проблемы протухания токенов.
         * @request GET:/v2/activityByService/{id}
         * @secure
         */
            activityByServiceDetail: (_a, params) => {
                var { id } = _a, query = __rest(_a, ["id"]);
                if (params === void 0) { params = {}; }
                return this.request(Object.assign({ path: `/v2/activityByService/${id}`, method: 'GET', query: query, secure: true, format: 'json' }, params));
            },
            /**
             * No description
             *
             * @tags Views
             * @name ViewsReviewPartialUpdate
             * @summary Добавляет просмотр
             * @request PATCH:/v2/views/review/{id}
             */
            viewsReviewPartialUpdate: (id, params = {}) => this.request(Object.assign({ path: `/v2/views/review/${id}`, method: 'PATCH', format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Views
             * @name ViewsReviewsList
             * @summary Получает просмотры отзывов по их идентификаторам
             * @request GET:/v2/views/reviews
             */
            viewsReviewsList: (query, params = {}) => this.request(Object.assign({ path: `/v2/views/reviews`, method: 'GET', query: query, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Votes
             * @name VoteCreate
             * @summary Добавляет лайк/дислайк
             * @request POST:/v2/vote
             * @secure
             */
            voteCreate: (data, params = {}) => this.request(Object.assign({ path: `/v2/vote`, method: 'POST', body: data, secure: true, type: ContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
